import { useTranslation } from "react-i18next";
import { HeroSearchForm } from "./HeroSearchForm";

export const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[85vh] overflow-hidden" aria-label="Banner principal">
      {/* Background — LCP mobile. As URLs devem bater exatamente com o
          <link rel="preload" imagesrcset> em src/routes/index.tsx. */}
      <img
        src="https://images.unsplash.com/photo-1483729558449-99ef09a8c325?auto=format&fit=crop&w=480&q=35"
        srcSet="https://images.unsplash.com/photo-1483729558449-99ef09a8c325?auto=format&fit=crop&w=480&q=35 480w, https://images.unsplash.com/photo-1483729558449-99ef09a8c325?auto=format&fit=crop&w=768&q=38 768w, https://images.unsplash.com/photo-1483729558449-99ef09a8c325?auto=format&fit=crop&w=1080&q=38 1080w, https://images.unsplash.com/photo-1483729558449-99ef09a8c325?auto=format&fit=crop&w=1280&q=40 1280w, https://images.unsplash.com/photo-1483729558449-99ef09a8c325?auto=format&fit=crop&w=1920&q=50 1920w"
        sizes="100vw"
        alt="Paisagem de praia no Brasil - viagens e resorts"
        fetchPriority="high"
        loading="eager"
        decoding="async"
        width={1920}
        height={1080}
        className="absolute inset-0 h-full w-full object-cover"
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-foreground/80 via-foreground/50 to-transparent" />
      
      <div className="container relative mx-auto flex min-h-[85vh] flex-col justify-center px-4 py-20">
        <div className="mb-12 max-w-2xl">
          {/* Subtitle Badge */}
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-primary-foreground/20 bg-primary-foreground/10 px-4 py-2 backdrop-blur-sm">
            <div className="relative flex h-2 w-2 items-center justify-center">
              <span className="absolute h-2 w-2 animate-ping rounded-full bg-primary opacity-75" />
              <span className="relative h-2 w-2 rounded-full bg-primary" />
            </div>
            <span className="text-sm font-medium text-primary-foreground">{t('hero.subtitle')}</span>
          </div>
          
          {/* Main Title */}
          <h1 className="mb-6 font-serif text-4xl font-bold leading-tight text-primary-foreground md:text-5xl lg:text-6xl">
            {t('hero.title')}
          </h1>
          
          {/* Description */}
          <p className="mb-8 max-w-lg text-lg text-primary-foreground/80">
            {t('hero.subtitle')}
          </p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8">
            <div className="border-l-2 border-primary pl-4">
              <div className="text-2xl font-bold text-primary-foreground md:text-3xl">500+</div>
              <div className="mt-1 text-sm text-primary-foreground/70">{t('nav.hotels')}</div>
            </div>
            <div className="border-l-2 border-primary pl-4">
              <div className="text-2xl font-bold text-primary-foreground md:text-3xl">50+</div>
              <div className="mt-1 text-sm text-primary-foreground/70">{t('home.stats.destinations')}</div>
            </div>
            <div className="border-l-2 border-primary pl-4">
              <div className="text-2xl font-bold text-primary-foreground md:text-3xl">4.9</div>
              <div className="mt-1 text-sm text-primary-foreground/70">{t('home.stats.rating')}</div>
            </div>
          </div>
        </div>

        {/* Search Form */}
        <div className="mt-8">
          <HeroSearchForm />
        </div>
      </div>

      {/* Decorative Element - Bottom */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg
          viewBox="0 0 1440 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
          preserveAspectRatio="none"
        >
          <path
            d="M0 60L1440 60L1440 30C1200 50 960 10 720 30C480 50 240 10 0 30L0 60Z"
            fill="hsl(var(--background))"
          />
        </svg>
      </div>
    </section>
  );
};
